import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/admin/whatsapp/")({
  beforeLoad: ({ search }) => {
    const tab = (search as Record<string, unknown>).tab;
    throw redirect({
      to: "/admin/channels",
      search: { network: "whatsapp", section: tab === "provider" ? "provider" : "groups" },
      replace: true,
    });
  },
});
